var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leading-normal tracking-normal",attrs:{"id":"main-body"}},[_c('div',{staticClass:"h-screen flex justify-center"},[_c('div',{staticClass:"container flex justify-center items-center flex-wrap h-full px-6 py-12",attrs:{"id":"main-content"}},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }